

































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";

import ItemImageJson, { imageDataUrlMaxLength } from "../../shared/ItemImageJson";
import EventImageJson from "../../shared/EventImageJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "FormImageBase64",
  components: {
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Object as PropType<ItemImageJson | EventImageJson>,
    editable: Boolean,
    accept: Array as PropType<string[]>,
    hideInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    customId: {
      default: "0",
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      imageDataUrlMaxLength: imageDataUrlMaxLength,
      details: {} as ItemImageJson | EventImageJson,
      hintChanged: {},
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;
    },

    async selectFile(e: Event & { target: HTMLInputElement }) {
      if (this.details != null) {
        if (e.target && e.target.files && e.target.files.length > 0) {
          let file = e.target.files[0] as File;

          if (!file.type.match(this.accept.join("|"))) {
            alert("Der ausgewählte Dateityp wird nicht unterstützt.");
            return;
          }

          if (file.size > this.imageDataUrlMaxLength) {
            alert("Die Datei darf maximal 10 MB groß sein. Bitte wählen Sie eine andere Datei aus.");
            return;
          }

          try {
            this.details.url = await this.convertFileToBase64(file);
          } catch (e) {
            this.details.url = "";
            alert("Es ist ein Fehler aufgetreten: " + e);
          }
        }
      }
    },

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "image", key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async convertFileToBase64(file: File): Promise<string> {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function () {
          if (reader != null) {
            resolve(reader.result as string);
          }
        };

        reader.onerror = function (error) {
          reject(error);
        };
      });
    },

    removeFile() {
      this.$emit("delete");
    },
  },

  watch: {
    data: function () {
      this.details = this.data;
    },

    details: {
      handler(val, oldVal) {
        this.$emit("change", this.details);
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    formatAccept() {
      return this.accept.map((i: string) => "." + i).join(",");
    },
  },
});
